// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1WYKY","label":"CategoryService_label__2yMs3","location":"CategoryService_location__2n-eL"};